import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Col, Form } from "react-bootstrap";
import FormSelect from "src/components/FormSelect";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import onChangeToValue from "src/functions/onChangeToValue";
import optionsDifficulty from "src/functions/optionsDifficulty";
import optionsFocus from "src/functions/optionsFocus";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sNote } from "src/styles/sNote.module.scss";

type Props = {
  item: number;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  formDataClassTitle: DynamicValue<string | undefined>;
  formDataClassFocus: DynamicValue<string | undefined>;
  formDataClassDifficulty: DynamicValue<string | undefined>;
  formDataClassShortDescription: DynamicValue<string | undefined>;
  formDataClassVideo: DynamicValue<string | undefined>;
};

function FormJoinUsClass({
  item,
  className,
  style,
  formDataClassTitle,
  formDataClassFocus,
  formDataClassDifficulty,
  formDataClassShortDescription,
  formDataClassVideo,
}: Props) {
  const { locale: lang } = useRouter();
  return (
    <div
      className={composeClassNames([className, "joinus-class"])}
      style={style}
    >
      <Heading
        type={`h4`}
        title={
          <div>
            <Translate tKey={`Sample class`} />
            {` `}
            {withDefault(item, 1)}
          </div>
        }
      />
      <Form.Row>
        <Col sm={4} xs={12}>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Title`} />
            </Form.Label>
            <Form.Control
              className={sFormControl}
              name={`class-title-` + String(item)}
              id={`class-title-` + String(item)}
              onChange={function (param2) {
                return formDataClassTitle.change(onChangeToValue(param2));
              }}
              value={formDataClassTitle.value}
            />
          </Form.Group>
        </Col>
        <Col sm={4} xs={12}>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Focus`} />
            </Form.Label>
            <FormSelect
              as={`select`}
              className={sFormControl}
              options={optionsFocus(lang)}
              name={`class-focus-` + String(item)}
              id={`class-focus-` + String(item)}
              onChange={function (param2) {
                return formDataClassFocus.change(onChangeToValue(param2));
              }}
              value={formDataClassFocus.value}
            />
          </Form.Group>
        </Col>
        <Col sm={4} xs={12}>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Difficulty`} />
            </Form.Label>
            <FormSelect
              as={`select`}
              className={sFormControl}
              options={optionsDifficulty(lang)}
              name={`class-difficulty-` + String(item)}
              id={`class-difficulty-` + String(item)}
              onChange={function (param2) {
                return formDataClassDifficulty.change(onChangeToValue(param2));
              }}
              value={formDataClassDifficulty.value}
            />
          </Form.Group>
        </Col>
      </Form.Row>
      <Form.Group>
        <Form.Label className={sFormLabel}>
          <Translate tKey={`Short description about class`} />
        </Form.Label>
        <Form.Control
          as={`textarea`}
          rows={2}
          className={sFormControl}
          name={`class-short-description-` + String(item)}
          id={`class-short-description-` + String(item)}
          onChange={function (param2) {
            return formDataClassShortDescription.change(
              onChangeToValue(param2)
            );
          }}
          value={formDataClassShortDescription.value}
        />
      </Form.Group>
      <Form.Row>
        <Col sm={8} xs={12}>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Link to video`} />
            </Form.Label>
            <Form.Control
              className={sFormControl}
              name={`class-video-` + String(item)}
              id={`class-video-` + String(item)}
              onChange={function (param2) {
                return formDataClassVideo.change(onChangeToValue(param2));
              }}
              value={formDataClassVideo.value}
            />
            <Form.Text className={sNote}>
              <Translate
                tKey={`The path to the video placed on YouTube, Vimeo, etc.`}
              />
            </Form.Text>
          </Form.Group>
        </Col>
      </Form.Row>
    </div>
  );
}

export default FormJoinUsClass;
